import React from "react";

const Card = ({ item, onApply }) => {
  return (
    <div
      data-aos={`${item.id % 2 === 0 ? "fade-right" : "fade-left"}`}
      style={{ fontFamily: "Nunito, sans-serif" }}
      className="px-4 py-6 md:px-8 md:py-8 flex flex-col gap-5 border text-base md:text-lg border-[#1C29A0] rounded-md"
    >
      <h2 className="text-[#0218DC] font-[520] text-lg md:text-xl">{item?.title}</h2>
      <div className="flex gap-2">
        <h3 className="text-[#000000] text-md font-semibold">Location:</h3>
        <p className="text-[#4A4848] text-sm md:text-md">{item?.Location}</p>
      </div>
      <div className="flex gap-2">
        <h3 className="text-[#000000] text-md font-semibold">Department:</h3>
        <p className="text-[#4A4848] text-sm md:text-md">{item?.Department}</p>
      </div>
      <div className="flex gap-2">
        <h3 className="text-[#000000] text-md font-semibold">Experience:</h3>
        <p className="text-[#4A4848] text-sm md:text-md">{item?.Experience}</p>
      </div>
      <button
        className="py-2 w-full md:w-[42%] rounded-md text-white font-medium bg-[#0218DC]"
        onClick={onApply} 
      >
        Apply
      </button>
    </div>
  );
};

export default Card;
